const { DoubleSidedImage } = require('components/shared')

const ImageDescription = (props) => {
    const { fileSize, fileType, storageUnit, children } = props
    console.log('componentType', typeof children === 'function')
    return (
        <div className="my-16 text-center">
            <DoubleSidedImage
                className=" mx-auto h-16 w-10 2xl:h-16 w-16"
                src="/img/others/upload.png"
                darkModeSrc="/img/others/upload-dark.png"
            />

            <p className=" text-xs mt-1 opacity-60 dark:text-white">
                {fileType}
            </p>
            <p className=" text-xs mt-1 opacity-60 dark:text-white">
                {`Max. ${fileSize} ${storageUnit}`}
            </p>
            <p className=" text-xs mt-1 mb-1 opacity-60 dark:text-white">
                {typeof children === 'function' ? children() : children}
            </p>
        </div>
    )
}
export default ImageDescription
